import React from "react";
import { Provider } from "react-redux";
import { store } from "./app/store";

import Routes from "./routes/index";

import { Notifications,ShowErrorAlert } from "@common";
import { setupAxiosInterceptor } from "./api/setupAxiosInterceptor"; 

function App() {
  setupAxiosInterceptor();
    return (
      <Provider store={store}>
        <Notifications />
        <ShowErrorAlert />
        <Routes />
      </Provider>
    );
}

export default App;
